module.exports = __webpack_public_path__ + "img/grid-inactive.113a1073.svg";